export default class Obstacle extends Phaser.GameObjects.Image {
    public body: Phaser.Physics.Arcade.Body;
    private _speed: number;
    private _boundaryBottom: number; // bottom boundary
    private _lane: any;
    private _stopCallback: Function;
    public tag: string;
    private _move: Function;
    constructor(scene: Phaser.Scene, x: number, y: number, key: string, frame: string) {
        super(scene, x, y, key, frame);
        this.tag = frame;
        scene.add.existing(this);
        this._boundaryBottom = window.constants.BASE_HEIGHT + this.height;
        this.setOrigin(0.5, 0.5);
        this._move = this._moveDown.bind(this);
        this._initPhysics();
        this.stop();
    }

    private _initPhysics(): void {
        this.scene.physics.world.enable(this);
        this.body.setAllowGravity(false);
        this.body.setAllowDrag(false);
        this.body.setAllowRotation(false);
        this.body.setImmovable();
        this.body.moves = false;
        // window.constants["OBSTACLE"].width
        let colliderData = window.constants.DATA.colliders[this.tag];
        this.body.setSize(colliderData.width, colliderData.height);
        this.body.setOffset(colliderData.x, colliderData.y);
        this.setOrigin(colliderData.pivotX, colliderData.pivotY);
        // console.log()
    }

    private _moveOffScreen() {
        this.x = window.constants.BASE_WIDTH + 100;
        this.y = window.constants.BASE_HEIGHT + 600;
    }

    update(time, dt) {
        if (this.active) {
            let delta = Math.floor(dt * 10) * 0.0001;
            this._move(time, delta)
            if (this.y > this._boundaryBottom) {
                this.stop();
            }
            if(window.constants["GAME_OVER"]){
                this.freeze();
            }
        }
    }

    public setProperties(speed: number, lane: any, stopCallback: Function) {
        // this.setScale(window.constants["OBJECT_SCALE"]);
        this._speed = speed;
        this._lane = lane;
        this.setPosition(this._lane.position.x, this._lane.position.y);
        if(stopCallback)
        {
            this._stopCallback = stopCallback;
        }
    }

    private _moveDown(time, dt) {
        this.y += this._speed * dt;
    }

    private _startPhysics() {
        this.scene.physics.world.enable(this);
        this.body.setEnable(true);
        this.body.reset(this._lane.position.x, this._lane.position.y - (this.height / 2));
        this.body.setVelocityY(this._speed);
    }

    private _stopPhysics() {
        this.scene.physics.world.disable(this);
        this.body.setEnable(false);
        this.body.stop();
    }

    public start(lane: any) {
        // console.log(this.tag + " has a depth "+ this.depth);
        this.setActive(true);
        this.setVisible(true);
        this._move = this._moveDown.bind(this);
        this._startPhysics();
        this._lane = lane;
        this._lane.isReservedLane = true;
        this.setPosition(this._lane.position.x, Math.floor(this._lane.position.y - (this.height * 0.5)))
    }

    public stop() {
        this.setActive(false);
        this.setVisible(false);
        this._stopPhysics();
        this._moveOffScreen();
        if(this._lane)
        {
            this._lane.isReservedLane = false;
        }
        if(this._stopCallback)
        {
            this._stopCallback();
        }
    }

    public freeze() {
        // if(this.body.velocity.y > 0) {
        //     this.body.setVelocityY(0);
        // }
        this._move = function(){};
    }

    public hit() {

    }

    public getScene() {
        return this.scene;
    }
}